<!-- 批量导入编目 -->
<template>
  <div>
    <el-dialog width="660px" title="批量导入编目" :visible.sync="importDialogVisible" showClose append-to-body center >
      <cs-form ref="batchImportForm" labelWidth="105px" formWidth="80%" :form="searchParams" :formData="searchData" :rules="rules">
      </cs-form>
      <div class="flex-box">
        <el-button class="button" @click="downloadExcl" type="primary" plain>下载excel模板</el-button>
        <el-upload class="upload-demo" multiple name="excel"
          :limit="1"
          :data="uploadForm"
          :action="upLoadExcelUrl"
          :headers="resHeader"
          :on-remove="handleRemove"
          :accept="upExcelFile"
          :on-preview="handlePreview"
          :on-exceed="handleExceed"
          :on-success="handleUpdate"
          :on-error="handleErroe"
          :before-upload="beforeAvatarUpload"
          :auto-upload="true"
          :with-credentials="true"
          :file-list="fileList">
          <el-button  plain type="primary">上传excel模板</el-button>
        </el-upload>
      </div>
      <p class="padding-top-20">1、下载编目的模版，填写编目信息</p>
      <p>2、上传填好的文件</p>
    </el-dialog>
    <el-dialog width="660px" title="具体信息" :visible.sync="msgDialog" showClose append-to-body center class="word">
      <span><pre id="showJson" style="text-align: left">{{premsg}}</pre></span>
    </el-dialog>
  </div>
</template>
<script>
import { fetchTencentTemplate, fetchDownloadCos } from '@/resource/api/index'
import SparkMD5 from 'spark-md5'
export default {
  name: 'BatchImport',
  data () {
    var validatePass = (rule, value, callback) => {
      if (value == '' && this.searchParams.needTrans == 0) {
        callback(new Error('请选择模版'))
      } else {
        callback()
      }
    }
    return {
      msgDialog: false,
      premsg: '',
      upExcelFile: '.xls,.xlsx,.xlsm',
      upLoadExcelUrl: process.env.VUE_APP_BASE_API_MGR + '/programs/excelNew',
      resHeader: {
        enctype: 'multipart/form-data'
      },
      fileList: [], // 上传文件列表
      uploadForm: {
        createTime: this.$moment().format('YYYY/MM/DD'),
        columnName: '',
        premiereChannel: '',
        createBy: '',
        ftpUser: this.$store.state.router.cpcode,
        md5: '',
        needCheck: '',
        needTrans: '',
        templateId: '',
        uploadWay: 'ftp'
      },
      rules: {
        needTrans: [
          { required: true, message: '请选择是否转码', trigger: 'change' }
        ],
        needCheck: [
          { required: true, message: '请选择是否送审', trigger: 'change' }
        ],
        templateId: [
          { validator: validatePass, trigger: 'change' }
        ]
      },
      importDialogVisible: false,
      isChange: 15,
      searchParams: {
        needTrans: 1,
        templateId: '',
        needCheck: null
      },
      unCodeDisabled: true,
      templateOptionList: []
    }
  },
  methods: {
    // 获取模版数据
    fetchTencentTemplate () {
      const that = this
      that.templateOptionList = []
      fetchTencentTemplate().then((res) => {
        if (res.code == '1') {
          const arr = res.results
          arr.forEach(function (item) {
            that.templateOptionList.push({ label: item.Name, value: item.Definition })
          })
        }
      })
    },
    open () {
      this.importDialogVisible = true // 打开弹出框
      this.$nextTick(() => {
        this.$refs.batchImportForm.resetFields()
      })
      this.unCodeDisabled = true
      this.fileList = []
      this.uploadForm.createBy = this.$store.state.router.createBySuffix
    },
    // 是否转码
    selectChangeTemplate (val) {
      if (val == 1) {
        this.unCodeDisabled = true
      } else {
        this.unCodeDisabled = false
        this.fetchTencentTemplate()
      }
    },
    handleClose () {
      this.importDialogVisible = false
    },
    // 下载模板TODO:
    downloadExcl () {
      fetchDownloadCos().then((res) => {
        if (res.code == '1') {
          window.location.href = res.result
        }
      })
    },
    handlePreview (file) {
      console.log(file)
    },
    handleExceed (files, fileList) {
      this.$message.warning('当前限制选择 1 个文件')
    },
    handleRemove (file, fileList) {
      this.$nextTick(() => {
        this.$refs.batchImportForm.validateField()
      })
    },
    handleUpdate (response, file, fileList) {
      if (response.code) {
        const someVar = response.msg
        if (someVar.indexOf('{') != -1) {
          this.msgDialog = true
          this.premsg = JSON.parse(response.msg)
        } else {
          this.$message({
            message: response.msg,
            type: 'success'
          })
        }
      } else {
        this.$message({
          message: response.msg,
          type: 'error'
        })
      }
      fileList.splice(0, 1)
    },
    handleErroe (response, file, fileList) {
      if (response.code) {
        this.$message({
          message: response.msg,
          type: 'error'
        })
      }
      fileList.splice(0, 1)
    },
    // 校验excel
    beforeAvatarUpload (file) {
      var that = this
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'xls' || testmsg === 'xlsx' || testmsg === 'xlsm'
      const isLt2M = file.size / 1024 / 1024 < 15
      if (!extension) {
        this.$message({
          message: '上传文件只能是.xls或.xlsx或.xlsm格式!',
          type: 'warning'
        })
        return false
      }
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 15MB!',
          type: 'warning'
        })
        return false
      }
      return that.getMd5(file)
    },
    getMd5 (file) {
      var that = this
      return new Promise((resolve, reject) => {
        that.$refs.batchImportForm.validate((valid) => {
          if (valid) {
            this.uploadForm.needCheck = this.searchParams.needCheck
            this.uploadForm.needTrans = this.searchParams.needTrans
            this.uploadForm.templateId = this.searchParams.templateId
            var sourceFile = file
            var fileReader = new FileReader()
            var blobSlice = File.prototype.mozSlice || File.prototype.webkitSlice || File.prototype.slice
            var chunkSize = 5 * 1024 * 1024
            var chunks = Math.ceil(sourceFile.size / chunkSize)
            var currentChunk = 0
            // // 注意点，网上都是 这一步都是有问题的， SparkMD5.ArrayBuffer()
            const spark = new SparkMD5()
            fileReader.onload = function (e) {
              spark.appendBinary(e.target.result) // append binary string
              currentChunk++
              if (currentChunk < chunks) {
                loadNext()
              } else {
                that.uploadForm.md5 = spark.end()
                resolve()
                return that.upLoadUrl
              }
            }
            var loadNext = function loadNext () {
              var start = currentChunk * chunkSize
              var end = start + chunkSize >= sourceFile.size ? sourceFile.size : start + chunkSize
              fileReader.readAsBinaryString(blobSlice.call(sourceFile, start, end))
            }
            loadNext()
          } else {
            that.$message.error('您的输入有误,请重新输入后确定.')
            reject(new Error('您的输入有误'))
            return false
          }
        })
      })
    }
  },
  computed: {
    searchData () {
      return [
        {
          prop: 'needTrans',
          type: 'select',
          label: '是否转码：',
          placeholder: '转码',
          options: [
            { label: '是', value: 0 },
            { label: '否', value: 1 }
          ],
          change: this.selectChangeTemplate
        },
        {
          prop: 'templateId',
          type: 'select',
          label: '模板：',
          placeholder: '请选择转码模板',
          disabled: this.unCodeDisabled,
          options: this.templateOptionList
        },
        {
          prop: 'needCheck',
          type: 'select',
          label: '是否送审：',
          placeholder: '立即送审',
          options: [
            { label: '是', value: 2 },
            { label: '否', value: 4 }
          ]
        },
        { prop: 'submit', type: 'slot' } // [xs,sm,md,lg] 布局
      ]
    }
  }
}
</script>
<style scoped lang="less">
  .padding-top-20{
    padding-top: 20px;
  }
  .flex-box {
    display: flex;
    justify-content: center;
    padding: 15px 0;
    .button{
      height: 32px;
      margin-right: 50px;
    }
  }
</style>
